export default __webpack_public_path__ + "static/media/octopus.9c7561ea.svg";